import { EDIT_CARD_MODAL_ID, PROFILE_CONSTANTS } from '../../modules';

// Test IDs for WalletSavedCardsSection
export const WALLET_SAVED_CARDS_TEST_IDS = {
  root: 'wallet-saved-cards-section',
  boundlessBanner: 'wallet-boundless-benefits-banner',
  boundlessBannerImage: 'wallet-boundless-benefits-banner-image',
  boundlessBannerCta: 'wallet-boundless-benefits-banner-cta',
  boundlessBannerBenefit: 'wallet-boundless-benefits-banner-benefit',
  cardsList: 'wallet-saved-cards-list',
  cardRow: 'wallet-saved-card-row',
  addCardRow: 'wallet-add-card-row',
  addCta: 'wallet-add-card-cta',
  editCta: 'wallet-edit-card-cta',
  deleteCta: 'wallet-delete-card-cta',
  folioDeliveryCta: 'wallet-folio-delivery-cta',
  primaryBadge: 'wallet-primary-badge',
  skeletonLoader: 'wallet-saved-cards-skeleton',
};

export const BOUNDLESS_ISSUER_PRODUCT_CODES = ['PREP', 'CH-PREP'];

// Tracking keys for analytics
export const WALLET_SAVED_CARDS_TRACKING_KEYS = {
  addCta: 'addCta',
  editCta: 'editCta',
  deleteCta: 'deleteCta',
  folioDeliveryCta: 'folioDeliveryCta',
};

// Modal IDs — must stay identical to the Profile page values so the BAU AddCard/UpdateCard
// modals (mi-aem-account/components/content/addcard) open from the Wallet tab unchanged.
export const SAVED_CARDS_MODAL_IDS = {
  ADD_CARD: PROFILE_CONSTANTS.DYNAMIC_LINE_ITEM_ID.ADD_CARD,
  EDIT_CARD: EDIT_CARD_MODAL_ID,
  FOLIO_DELIVERY: 'folio-delivery-saved-card',
  DELETE_CARD: 'delete-saved-card',
};

// Profile hides the Add CTA once a member reaches this many cards
export const MAX_SAVED_CARDS = 10;
